import React, { createContext, PureComponent } from 'react';
import PropTypes from 'prop-types';

import PageComponentTracker from '../services/PageComponentTracker';
import { checkPageView, PageViewConsumer, propTypesOfPageViewContext } from './PageView';
import componentTypes from 'apps/analytics/utils/componentTypes';

const { Provider, Consumer } = createContext();

const propTypesOfPageComponent = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(componentTypes)),
};

class PageComponentInternal extends PureComponent {
  static propTypes = {
    ...propTypesOfPageViewContext,
    ...propTypesOfPageComponent,
  };

  componentDidMount = () => {
    this.track();
  };

  componentDidUpdate = () => {
    this.track();
  };

  get trackerContext() {
    return {
      addFieldToComponent: this.pageComponentTracker.addField,
    };
  }

  track() {
    const { pageView } = this.props;
    checkPageView(pageView);

    this.pageComponentTracker.configurePageComponent(this.props);
    pageView.addPageComponent(this.pageComponentTracker.pageComponent);
    this.pageComponentTracker.createNewPageComponent();
  }

  pageComponentTracker = new PageComponentTracker();

  render() {
    return (
      <Provider value={this.trackerContext}>
        {this.props.children}
      </Provider>
    );
  }
}

const PageComponent = (props) => (
  <PageViewConsumer>
    {context => <PageComponentInternal {...context} {...props} />}
  </PageViewConsumer>
);

PageComponent.propTypes = propTypesOfPageComponent;

export { Consumer as PageComponentConsumer };

export const propTypesOfPageComponentContext = {
  addFieldToComponent: PropTypes.func.isRequired,
};

export default PageComponent;
